import { SET_REFERRAL_DATA } from './type';

const initialState: {
  referralLink: string;
  referralMessage: string;
  referralCode: string;
} = {
  referralLink: '',
  referralMessage: '',
  referralCode: '',
};

function referralReducer(state = initialState, action) {
  const { type, data } = action;

  switch (type) {
    case SET_REFERRAL_DATA:
      state = data;
      return state;
    default:
      return state;
  }
}

export default referralReducer;
